<div *ngIf="errorMsg" class="card text-white bg-danger mb-3" style="max-width: 80%; margin: 20px auto;">
  <div class="card-header">خطا
      <button type="button" class="btn btn-warning float-left" (click)="return()">بازگشت به صفحه اصلی</button>
  </div>
  <div class="card-body">
    <h5 class="card-title">{{errorMsg}}</h5>
  </div>
</div>